"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _tieTuNumber = _interopRequireDefault(require("@/api/activity/tieTuNumber.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'tieTuRecordList',
  props: {
    actId: {
      type: [Number, String],
      default: null
    },
    mode: {
      type: String,
      default: 'publish'
    }
  },
  computed: {
    isReward: function isReward() {
      return this.mode === 'reward';
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newId) {
        this.searchForm.activityId = this.normalizeActId(newId);
        this.searchForm.page = 1;
        this.fetchList();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      times: [],
      actList: [],
      searchForm: {
        activityId: null,
        keywords: '',
        receiveStatus: null,
        startTime: '',
        endTime: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: []
    };
  },
  mounted: function mounted() {
    this.fetchActList();
  },
  methods: {
    normalizeActId: function normalizeActId(id) {
      if (id === null || id === undefined || id === '' || id === 'null' || id === 'NaN') {
        return null;
      }
      return String(id);
    },
    fetchActList: function fetchActList() {
      var _this = this;
      _tieTuNumber.default.getActList({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this.actList = res.records || [];
      });
    },
    changeTime: function changeTime(e) {
      if (!e || e.length === 0) {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList();
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
      }
    },
    buildQuery: function buildQuery() {
      var params = Object.assign({}, this.searchForm);
      params.receiveStatus = this.isReward ? 1 : null;
      return params;
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      _tieTuNumber.default.getRecordList(this.buildQuery()).then(function (res) {
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleSizeChange: function handleSizeChange(n) {
      this.searchForm.limit = n;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(n) {
      this.searchForm.page = n;
      this.fetchList();
    },
    formatDate: function formatDate(val) {
      if (!val) return '-';
      if (typeof val === 'string' && val.indexOf('T') < 0 && val.length >= 19) {
        return val.substring(0, 19);
      }
      var d = val instanceof Date ? val : new Date(val);
      if (isNaN(d.getTime())) return val;
      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    },
    copyPostUrl: function copyPostUrl(row) {
      var _this3 = this;
      var text = row.postUrl;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          _this3.$message.success('已复制');
        }).catch(function () {
          _this3.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    fallbackCopy: function fallbackCopy(text) {
      var input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('已复制');
    },
    openPostUrl: function openPostUrl(row) {
      if (row.postUrl) {
        window.open(row.postUrl, '_blank');
      }
    },
    exportData: function exportData() {
      var _this4 = this;
      _tieTuNumber.default.exportRecordData(this.buildQuery()).then(function (res) {
        var blob = new Blob([res], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = _this4.isReward ? '贴图号领奖记录.xlsx' : '贴图号发帖记录.xlsx';
        link.click();
      });
    }
  }
};